import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { DealerFeature, HyundaiPromiseFeature } from '@hyundai/ng-common-lib';
import { PromisePageLibComponent } from '@hyundai/vehicle-market-lib';
import { Store } from '@ngrx/store';
import { GlobalContactComponent } from '../../components/global-contact/global-contact.component';

@Component({
    selector: 'app-promise-page',
    standalone: true,
    template: `
        <lib-promise-page
            [locationHeadline]="locationHeadline()"
            [dealerHcmUrl]="'/' + dealer().slug + '/fahrzeugbestand'"
        >
            <app-global-contact isFirstView="false" />
        </lib-promise-page>
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [GlobalContactComponent, PromisePageLibComponent],
})
export class PromisePageComponent {
    store = inject(Store);
    dealer = this.store.selectSignal(DealerFeature.state.selectLoadedDealer);
    dealerContactMailLink = this.store.selectSignal(DealerFeature.state.selectDealerContactFormUrl);
    content = this.store.selectSignal(HyundaiPromiseFeature.state.selectLoadedContent);
    locationHeadline = this.store.selectSignal(DealerFeature.state.selectDealerLocationHeadline);
}
